<template>
  <multiSelect
    :value="actualLanguage"
    :options="languages"
    placeholder="Select language"
    label="value"
    track-by="key"
    :allowEmpty="false"
    :showLabels="false"
    @input="languageChanged"
  />
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import multiSelect from "vue-multiselect";
import { i18n, LANG_DE, LANG_EN } from "@/i18n/i18n";
import { useBoardStore } from "@/store/board/BoardStore";

export default defineComponent({
  name: "LanguageSwitcher",
  components: { multiSelect },
  setup() {
    const boardStore = useBoardStore();

    const language = computed(() => boardStore.language);

    const languages = ref([
      { key: LANG_EN, value: "English" },
      { key: LANG_DE, value: "Deutsch" }
    ]);
    const actualLanguage = computed(() => {
      return languages.value.find(language => language.key === i18n.locale);
    });

    const languageChanged = value => {
      //save it to user Profile
      boardStore.updateLanguage(value.key);
    };

    return {
      languageChanged,
      actualLanguage,
      languages,
      language
    };
  }
});
</script>

<style scoped></style>
